import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
// Material Imports
import { MatToolbarModule } from '@angular/material/toolbar';
import { AlunosModule } from '../modules/alunos';
import { QuestionarioModule } from '../modules/questionario';
import { AlunoService } from '../modules/services/aluno.service';
import { ComentariosService } from '../modules/services/comentarios.service';
import { EscolaService } from '../modules/services/escola.service';
import { PoaPeriodoService } from '../modules/services/poa-periodo.service';
import { ProfessorService } from '../modules/services/professor.service';
import { QuestionarioService } from '../modules/services/questionario.service';
import { SerieService } from '../modules/services/serie.service';
import { TurmaService } from '../modules/services/turma.service';
import { AutenticarInterceptor } from '../security/autenticar/autenticar.interceptor';
import { AutenticarService } from '../security/autenticar/autenticar.service';
import { ImagePreloadDirective } from '../shared/DefaultImage';
import { ErrorInterceptor } from '../shared/error/error.interceptor';
import { LoaderInterceptor } from '../shared/loader/loader.interceptor';
import { LoaderService } from '../shared/loader/loader.service';
import { SharedModule } from '../shared/shared.module';
import { AwsTokenInterceptor } from './aws_token.interceptor';
import { ContentComponent } from './content';
import { CoreRoutingModule } from './core-routing.module';
import { CoreComponent } from './core.component';
import { ToolbarComponent } from './toolbar';

@NgModule({
    declarations: [ToolbarComponent, CoreComponent, ContentComponent, ImagePreloadDirective],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        // Material Modules
        MatIconModule,
        MatToolbarModule,

        // App Modules
        SharedModule,
        AlunosModule,
        QuestionarioModule,
        CoreRoutingModule,
    ],
    providers: [
        PoaPeriodoService,
        EscolaService,
        SerieService,
        TurmaService,
        AlunoService,
        LoaderService,
        AutenticarService,
        ProfessorService,
        ComentariosService,
        QuestionarioService,
        { provide: HTTP_INTERCEPTORS, useClass: AutenticarInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AwsTokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
    ],
    entryComponents: [ToolbarComponent],
    exports: [ToolbarComponent],
})
export class CoreModule {}
